import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async index(params) {
    const res = await base.index({
      modelName: 'question_type',
      pagination: true,
      params,
    });
    return res;
  },
  async updateQuesTypeListInVuex() {
    const quesTypeList = store.state.model.quesTypeList;
    if (!quesTypeList.length) {
      const {data: newQuesTypeList} = await this.index();
      store.dispatch('model/setQuesTypeList', newQuesTypeList);
    }
  }
}